/**
 * POI Cost Dashboard Controller
 * 
 * Routes pour exposer les données de coûts POI au dashboard admin
 * Endpoints:
 *   GET /api/ai/costs/pois/dashboard - Complete dashboard data
 *   GET /api/ai/costs/pois/budget - Budget status
 *   GET /api/ai/costs/pois/sources - Breakdown by source
 *   GET /api/ai/costs/pois/zoom - Breakdown by zoom level
 */

import { FastifyRequest, FastifyReply } from 'fastify'
import { logger } from '../../../utils/logger.js'
import {
  getPOIDashboardData,
  getPOIBudgetStatus
} from '../integrations/poi-cost-dashboard-integration.js'

const log = logger

/**
 * GET /api/ai/costs/pois/dashboard
 * Get complete POI cost dashboard data
 */
export async function getPOICostDashboard(
  request: FastifyRequest,
  reply: FastifyReply
): Promise<void> {
  try {
    // Verify admin
    if (!request.user?.admin) {
      return reply.status(403).send({
        success: false,
        error: 'Admin access required'
      })
    }

    const data = getPOIDashboardData()
    log.debug('POI dashboard data requested')

    return reply.send(data)
  } catch (error) {
    log.error('Error getting POI cost dashboard', error)
    return reply.status(500).send({
      success: false,
      error: 'Failed to get POI cost dashboard'
    })
  }
}

/**
 * GET /api/ai/costs/pois/budget
 * Get current POI API budget status
 */
export async function getPOIBudgetSummary(
  request: FastifyRequest,
  reply: FastifyReply
): Promise<void> {
  try {
    // Verify admin
    if (!request.user?.admin) {
      return reply.status(403).send({
        success: false,
        error: 'Admin access required'
      })
    }

    const budgetStatus = getPOIBudgetStatus()
    log.debug('POI budget status requested')

    return reply.send(budgetStatus)
  } catch (error) {
    log.error('Error getting POI budget status', error)
    return reply.status(500).send({
      success: false,
      error: 'Failed to get POI budget status'
    })
  }
}

export default {}
